import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TrackingTimelineResponse } from 'src/app/model/trackingTimelineResponse.model';
import { DeliveryChoiceService } from 'src/app/services/delivery-choice.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ToasterComponent } from '../../Shared/toaster/toaster.component';
import { ClaimComponent } from '../claim/claim.component';
import { DeliveryDialogComponent } from '../delivery-choice/delivery-dialog/delivery-dialog.component';
import { HomeComponent } from '../delivery-choice/home/home.component';
import { AtInternetService } from '../../../services/at-internet.service';
import { PickupComponent } from '../delivery-choice/pickup/pickup.component';
import { Address } from 'src/app/model/address.model';
import { ConsigneeInformation } from 'src/app/model/consigneeInformation.model';
import { RemovalPoint } from 'src/app/model/removalPoint.model';

@Component({
  selector: 'app-cta-button',
  templateUrl: './cta-button.component.html',
  styleUrls: ['./cta-button.component.scss']
})

export class CtaButtonComponent {

  @Input() parcelInformations: TrackingTimelineResponse;
  @Input() titleBloc: string;
  @Input() button: string;
  @Input() popinType: string;
  @Input() changeRefNumber: (args: any) => void;
  @Input() shortCode1;
  @Input() shortCode2;
  @Input() tag;
  @Input() reasonCode: string;
  pdrListSize = 0;
  deliveryDate : Date;
  isHome : boolean;
  hasDeliveryInformation: boolean;
  deliveredHomeAddress: ConsigneeInformation;
  deliveredPickupAddress: RemovalPoint;
  //weekday = ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"];
  //dayOfWeek : string = "";

  constructor(
    private dialog: MatDialog,
    private deliveryChoiceService: DeliveryChoiceService,
    public spinnerService: SpinnerService,
    private _snackBar: MatSnackBar,
    private atInternetService: AtInternetService
  ) { }

  showSpinner: boolean;

  ngOnInit() {
    // if (this.parcelInformations.parcel.step[5].date && this.popinType === 'home') {
    //   this.deliveryDate = new Date(this.parcelInformations.parcel.step[5].date);
    //   this.hasDeliveryInformation = true;
    //   this.button = "deliveryChoice.modify";
    //   this.titleBloc = "deliveryChoice.modify_title";
    //   if (this.parcelInformations.parcel.removalPoint) {
    //     this.isHome = false;
    //     this.deliveredPickupAddress = this.parcelInformations.parcel.removalPoint;
    //   } else {
    //     this.isHome = true;
    //     this.deliveredHomeAddress = this.parcelInformations.parcel.consigneeInformation;
    //   }
    // }
    //SQUAD7-695 : ajouter le jour dans label
    // if (this.titleBloc.includes('absent')) {
    //   if (this.parcelInformations.parcel.step[5].date) {
    //     this.dayOfWeek = " " + this.weekday[new Date(this.parcelInformations.parcel.step[5].date).getDay()] + " ?";
    //   } else {
    //     if (this.parcelInformations.parcel.step[4].date) {
    //       this.dayOfWeek = " " + this.weekday[new Date(this.parcelInformations.parcel.step[4].date).getDay()] + " ?";
    //     } else {
    //       this.dayOfWeek = " ?";
    //     }
    //   }
    // }
  }

  callPopin(type: string) {
    if (type === "home") {
      this.deliveryChoiceService.trackParcelByParcelNumber(
        this.shortCode1,
        this.shortCode2,
        this.parcelInformations.parcel.consigneeInformation.address.zipCode,
        this.parcelInformations.lang).subscribe(
          response => {
            if (response != null) {
              this.atInternetService.generateClickAction(
                this.tag,
                'cta_reprogrammation',
                'vous_netes_pas_la'
              );
              // Deux options possibles relivraison à Domicile ou Point relais
              if ( response.deliveryInformation.pickupInformationList
                && response.deliveryInformation.pickupInformationList != null
                && response.deliveryInformation.pickupInformationList.length > 0
                && response.deliveryInformation.deliveryDatesList
                && response.deliveryInformation.deliveryDatesList != null
                && response.deliveryInformation.deliveryDatesList.length > 0
                && response.deliveryInformation.znl == false) {
                  this.atInternetService.generatePage(
                    this.tag,
                    'reprogrammation_choix',
                    'reprogrammation_choix'
                  );
                  this.dialog.open(DeliveryDialogComponent, { disableClose: true, panelClass: 'delivery-choice-dialog', data: { "deliveryChoiceResponse": response, "tag": this.tag, "shortCode1": this.shortCode1, "shortCode2": this.shortCode2, "isModify": true } });
              }
              // Seulement une relivraison à Domicile de disponible
              else if ( response.deliveryInformation.deliveryDatesList
                && response.deliveryInformation.deliveryDatesList != null
                && response.deliveryInformation.deliveryDatesList.length > 0
                && response.deliveryInformation.znl == false) {
                  this.atInternetService.generatePage(
                    this.tag,
                    'choix_relivraison_domicile',
                    'choix_relivraison_domicile'
                  );
                  this.dialog.open(HomeComponent, { disableClose: true, panelClass: 'homeChoice-dialog', data: { "deliveryChoiceResponse": response, "tag": this.tag, "shortCode1": this.shortCode1, "shortCode2": this.shortCode2, "isModify": false } });
              }
              // Seulement une relivraison en Point relais de disponible
              else if ((response.deliveryInformation.znl === true
                || response.deliveryInformation.znl === false && response.deliveryInformation.deliveryDatesList == null
                || !response.deliveryInformation.deliveryDatesList
                || response.deliveryInformation.deliveryDatesList.length==0)
                && response.deliveryInformation.pickupInformationList
                && response.deliveryInformation.pickupInformationList != null
                && response.deliveryInformation.pickupInformationList.length > 0) {
                  this.atInternetService.generatePage(
                    this.tag,
                    'choix_relivraison_hors_domicile',
                    'choix_relivraison_hors_domicile'
                  );
                  this.dialog.open(PickupComponent, { disableClose: true, panelClass: 'pickupChoice-dialog', data: { "deliveryChoiceResponse": response, "tag": this.tag, "shortCode1": this.shortCode1, "shortCode2": this.shortCode2, "isModify": false } });
              } else {
                this.openSnackBar();
              }
            }
          }
        )
    } else if (type === "claim") {
      if(this.reasonCode == "AF"){
          this.atInternetService.generateClickAction(
            this.tag,
            'cta_reclamation_AF',
            'le_facteur_n_a_pas_sonne'
          );
          this.dialog.open(ClaimComponent, { disableClose: true, panelClass: 'claim-dialog', data: { "parcelInformations": this.parcelInformations, changeRefNumber: this.changeRefNumber, "tag": this.tag, "reasonCode": this.reasonCode } });
        }
        else if ( this.reasonCode =="CL"){
          this.atInternetService.generateClickAction(
            this.tag,
            'cta_reclamation_CL',
            'le_colis_est_notifie_livre_mais_non_recu'
          );
          this.dialog.open(ClaimComponent, { disableClose: true, panelClass: 'claim-dialog', data: { "parcelInformations": this.parcelInformations, changeRefNumber: this.changeRefNumber, "tag": this.tag, "reasonCode": this.reasonCode } });
        }
      }
  }

  openSnackBar() {
    this._snackBar.openFromComponent(ToasterComponent, {
      data: 'error.technical_problem',
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}
